<template>
  <div class="p-message-edit">
    <div class="c-title">
      <div class="c-title__text u-fs24">配信されるメッセージ内容を作成する</div>
    </div>
    <div class="p-message-edit-list">
      <div class="p-message-edit-list__item p-message-edit-list__item--set-select-btn">
        <div v-show="isSystemAdminEdit()" class="c-checkbox">
          <label class="c-checkbox__label">
            <input v-model="adFlag" type="checkbox" value="1" />
            <div class="c-checkbox__item">
              <div class="c-checkbox__box"></div>
              <div class="c-checkbox__box-label">広告として設定する</div>
            </div>
          </label>
        </div>
      </div>
      <br />
      <div class="p-message-edit-list__item">
        <div class="c-input">
          <div class="c-input__title">
            <span class="c-input__text c-input__text--required">【必須】</span>タイトルを入力する
          </div>
          <input
            v-model="messageTitle"
            class="c-input__item"
            type="text"
            name="message_title"
            value=""
            placeholder="メッセージのタイトルを入力してください"
            maxlength="300"
          />
          <div class="c-error c-error--balloon">
            <div class="c-error__text"></div>
          </div>
        </div>
      </div>
      <div class="p-message-edit-list__item">
        <div class="c-textarea">
          <div class="c-textarea__title">
            <span class="c-input__text c-input__text--required">【必須】</span>メッセージの本文を入力する
          </div>
          <textarea
            v-model="messageText"
            class="c-textarea__item"
            name="message_content"
            placeholder="メッセージの本文を入力してください"
            style="resize: vertical;"
          ></textarea>
          <div class="c-error c-error--balloon">
            <div class="c-error__text"></div>
          </div>
        </div>
      </div>
      <div style="margin-bottom: 20px">
        <span
          id="clearMessageTitleContent"
          class="c-upload__btn"
          style="background: #fff; cursor: pointer"
          @click="clearMessageTitleContent"
        >
          タイトルと本文をクリア
        </span>
      </div>
      <div class="p-message-edit-list__item">
        <div class="c-input">
          <div class="c-input__title">
            <span class="c-input__text c-input__text--required">【必須】</span>遷移先のURLを設定する
            <span
              class="c-upload__btn"
              style="background: #fff; cursor: pointer; font-weight: normal"
              @click="addUtmPrameter"
            >
              UTMパラメータ追加
            </span>
          </div>
          <input
            v-model="clickUrl"
            class="c-input__item"
            type="text"
            name="redirect_url"
            value=""
            placeholder="例）https://webpush.jp/"
          />
          <div class="c-error c-error--balloon">
            <div class="c-error__text"></div>
          </div>
        </div>
        <div v-if="useCustomParameter" class="c-input" style="margin-top: 10px">
          <select-text
            ref="customUtmParameter"
            :classes="['u-w470']"
            place-holder="保存したUTMパラメーターを選択"
            :elements="customUtmParameters"
            :input-name="customUtmParameter"
            @select="onCustomUtmParameterSelect"
          />
        </div>
      </div>
      <div style="margin-bottom: 20px">
        <span
          class="c-upload__btn c-upload__btn--tooltip"
          :data-tooltip="canAnalyze
            ? 'AIがタイトル・本文・URLを分析し、Android端末で不正な通知と判定されるリスクを診断します'
            : 'タイトル・本文・URLをすべて入力すると利用できます'"
          :style="canAnalyze
            ? 'background: #3cb6d2; cursor: pointer; color: #fff; border-color: #3cb6d2'
            : 'background: #ccc; cursor: not-allowed; color: #fff; border-color: #ccc'"
          @click="canAnalyze && analyzeMessage()"
        >
          通知リスクをチェック
        </span>
      </div>
      <div class="p-message-edit-list__item">
        <div class="c-upload">
          <div class="c-upload__title">通知アイコンを設定する</div>
          <!--
                <div class="c-upload__link">
                    <a href="#">画像ストレージから追加</a>
                </div>
                -->
          <label class="c-upload__label">
            <div class="c-upload__image">
              <img v-if="iconUrl" :src="iconUrl" />
              <div v-else class="c-upload__noimage">
                <div class="c-icon c-icon--gray-3 u-wh30">
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <use xlink:href="/assets/img/sprite.svg#photo" />
                  </svg>
                </div>
              </div>
            </div>
            <div class="c-upload__data">
              <input
                ref="iconInput"
                type="file"
                name="message_icon"
                value=""
                placeholder="ファイルの選択"
                @change="selectIconFile"
              />
              <span class="c-upload__btn">ファイルの選択</span>
              <div class="c-upload__text c-upload__text--spec">
                サイズ：縦64x横64px～縦192x横192px<br />
                容量：5KB以内奨励(最大8KB)<br />
                形式：PNG奨励(JPG可)
              </div>
            </div>
          </label>
          <input type="hidden" name="message_icon_attachement_data" value="" />
          <div class="c-error" :class="{ 'is-active': errors.messageIcon !== '' }">
            <div class="c-error__text">{{ errors.messageIcon }}</div>
          </div>
        </div>
      </div>
      <div class="p-message-edit-list__item">
        <div class="c-upload">
          <div class="c-upload__title">追加大型画像を設定する</div>
          <div style="position: relative">
            <label class="c-upload__label">
              <div class="c-upload__image">
                <img v-if="largeImageUrl" id="largeImageUrl" :src="largeImageUrl" />
                <div v-else class="c-upload__noimage">
                  <div class="c-icon c-icon--gray-3 u-wh30">
                    <svg
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <use xlink:href="/assets/img/sprite.svg#photo" />
                    </svg>
                  </div>
                </div>
              </div>
              <div class="c-upload__data">
                <input
                  ref="largeImageInput"
                  type="file"
                  name="message_big_img"
                  value=""
                  placeholder="ファイルの選択"
                  @change="selectLargeImageFile"
                />
                <span class="c-upload__btn">ファイルの選択</span>
                <div class="c-upload__filename"></div>
                <div class="c-upload__text c-upload__text--spec">
                  サイズ：縦240x横480px<br />
                  容量：128KB以内奨励<br />
                  形式：PNG奨励(JPG可)<br />
                </div>
              </div>
              <span
                v-show="isDeprecatedSize"
                style="margin-top: 16px"
              >※設定画像サイズは非推奨です。端末によって表示が異なる可能性があります</span>
            </label>
            <span
              id="clearLargeImageButton"
              class="c-upload__btn"
              style="position: absolute; top: 28px; left: 270px; cursor: pointer"
              @click="clearLargeImageFile"
            >クリア</span>
          </div>
          <input type="hidden" name="message_big_img_attachement_data" value="" />
          <div class="c-error" :class="{ 'is-active': errors.messageLargeImage !== '' }">
            <div class="c-error__text">{{ errors.messageLargeImage }}</div>
          </div>
        </div>
      </div>

      <div class="p-message-edit-list__item">
        <div class="c-upload">
          <div class="c-upload__title" style="width: auto">ステータスアイコンを設定する</div>
          <div style="position: relative">
            <label class="c-upload__label">
              <div class="c-upload__image">
                <img v-if="badgeUrl" :src="badgeUrl" class="uploaded_transparent_image" />
                <div v-else class="c-upload__noimage">
                  <div class="c-icon c-icon--gray-3 u-wh30">
                    <svg
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <use xlink:href="/assets/img/sprite.svg#photo" />
                    </svg>
                  </div>
                </div>
              </div>
              <div class="c-upload__data">
                <input
                  ref="badgeInput"
                  type="file"
                  name="message_badge"
                  value=""
                  placeholder="ファイルの選択"
                  @change="selectBadgeFile"
                />
                <span class="c-upload__btn">ファイルの選択</span>
                <div class="c-upload__filename"></div>
                <div class="c-upload__text c-upload__text--spec">
                  サイズ：縦72x横72px～縦128x横128px<br />
                  5KB以内奨励(最大8KB)<br />
                  形式：PNG<br />
                </div>
              </div>
            </label>
            <span
              class="c-upload__btn"
              style="position: absolute; top: 28px; left: 270px; cursor: pointer"
              @click="clearBadgeFile"
            >クリア</span>

            <div class="c-help-tooltip">
              <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <use
                  xlink:href="/assets/img/sprite.svg#question"
                  style="fill: #999; cursor: pointer"
                />
              </svg>
              <span class="c-help-tooltip__text">
                <p>メッセージごとにステータスアイコンを設定した場合は優先して適用されます。</p>
                <p>
                  メッセージごとに設定しない場合は、プロジェクト編集のデフォルト設定のステータスアイコンが適用されます。
                </p>
                <p>どちらも設定していない場合はブラウザやベルのアイコンが適用されます。</p>
              </span>
            </div>
          </div>
          <input type="hidden" name="message_badge_attachement_data" value="" />
          <div class="c-error" :class="{ 'is-active': errors.messageBadge !== '' }">
            <div class="c-error__text">{{ errors.messageBadge }}</div>
          </div>
        </div>
      </div>

      <div class="p-message-edit-list__item p-message-edit-list__item--set-select-btn">
        <div class="c-checkbox">
          <label class="c-checkbox__label">
            <input
              v-model="hasButtonA"
              type="checkbox"
              name="is_set_select_btn"
              value="1"
            />
            <div class="c-checkbox__item">
              <div class="c-checkbox__box"></div>
              <div class="c-checkbox__box-label">選択ボタンを設定する</div>
            </div>
          </label>
          <div class="c-checkbox__text">※Windows、Android端末のみ表示されます</div>
          <div class="c-error">
            <div class="c-error__text"></div>
          </div>
        </div>
        <div class="p-message-edit-select-btn-list" :class="[hasButtonA ? 'is-active' : '']">
          <div class="p-message-edit-select-btn-list-group">
            <div class="p-message-edit-select-btn-list__item">
              <div class="c-input">
                <div class="c-input__title">選択ボタン1のタイトル</div>
                <input
                  v-model="actionButtonTextA"
                  class="c-input__item"
                  type="text"
                  name="select_btn_title_1"
                  value=""
                  placeholder="タイトルを入力してください"
                  :disabled="!hasButtonA"
                />
                <div class="c-error c-error--balloon">
                  <div class="c-error__text"></div>
                </div>
              </div>
              <div class="c-input">
                <div class="c-input__title">URL</div>
                <input
                  v-model="actionButtonUrlA"
                  class="c-input__item"
                  type="text"
                  name="select_btn_url_1"
                  value=""
                  placeholder="例）https://webpush.jp/"
                  :disabled="!hasButtonA"
                />
                <div class="c-error c-error--balloon">
                  <div class="c-error__text"></div>
                </div>
              </div>
              <div v-if="useCustomParameter" class="c-input">
                <select-text
                  ref="customUtmParameterActionA"
                  :classes="['u-w430']"
                  place-holder="保存したUTMパラメーターを選択"
                  :elements="customUtmParameters"
                  :input-name="customUtmParameterActionA"
                  @select="onCustomUtmParameterActionASelect"
                />
              </div>
            </div>
            <div v-if="hasButtonB" class="p-message-edit-select-btn-list__item">
              <button class="p-message-edit-select-btn-list__close" @click="hideButtonB">
                <div class="c-icon c-icon--gray-3 u-wh16">
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <use xlink:href="/assets/img/sprite.svg#close" />
                  </svg>
                </div>
              </button>
              <div class="c-input">
                <div class="c-input__title">選択ボタン2のタイトル</div>
                <input
                  v-model="actionButtonTextB"
                  class="c-input__item"
                  type="text"
                  name="select_btn_title_2"
                  value=""
                  placeholder="タイトルを入力してください"
                  :disabled="!hasButtonA"
                />
                <div class="c-error c-error--balloon">
                  <div class="c-error__text"></div>
                </div>
              </div>
              <div class="c-input">
                <div class="c-input__title">URL</div>
                <input
                  v-model="actionButtonUrlB"
                  class="c-input__item"
                  type="text"
                  name="select_btn_url_2"
                  value=""
                  placeholder="例）https://webpush.jp/"
                  :disabled="!hasButtonA"
                />
                <div class="c-error c-error--balloon">
                  <div class="c-error__text"></div>
                </div>
              </div>
              <div v-if="useCustomParameter" class="c-input">
                <select-text
                  ref="customUtmParameterActionB"
                  :classes="['u-w430']"
                  place-holder="保存したUTMパラメーターを選択"
                  :elements="customUtmParameters"
                  :input-name="customUtmParameterActionB"
                  @select="onCustomUtmParameterActionBSelect"
                />
              </div>
            </div>
          </div>
          <a
            v-if="!hasButtonB"
            class="c-btn c-btn--cancel c-btn--block is-active"
            href="#add-select-btn"
            @click="addButtonB"
          >
            <p class="c-btn__text">選択ボタンを追加する</p>
          </a>
        </div>
      </div>
    </div>
    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal :is-active="isError" :message="errorMessage" :on-close-click="onCloseErrorModal" />
    <!-- モーダル: 画像トリミング・圧縮（通知アイコン用） -->
    <image-cropper-modal ref="imageCropperModal" @cropped="onIconCropped" @cancelled="onIconCropCancelled" />
    <!-- モーダル: 通知リスクチェック -->
    <message-improve-modal
      :is-active="isImproveModalActive"
      :result="improveResult"
      :is-loading="isImproveLoading"
      :original-title="improveOriginalTitle"
      :original-text="improveOriginalText"
      @close="closeImproveModal"
      @apply="applyImprovement"
    />
    <!-- モーダル: 画像トリミング・圧縮（大型画像用） -->
    <image-cropper-modal
      ref="imageCropperModalLarge"
      modal-id="imageCropperModalLarge"
      modal-title="大型画像最適化"
      modal-description="画像サイズが128KBを超えています。<br>大型画像に使用する範囲を選択してください。<br>(横480×縦240px、128KB以下に自動変換されます)"
      :aspect-ratio="2"
      :output-width="480"
      :output-height="240"
      :max-file-size="131072"
      preferred-format="png"
      @cropped="onLargeImageCropped"
      @cancelled="onLargeImageCropCancelled"
    />
  </div>
</template>

<script>
import axios from 'axios';
import store from '../../funcs/store.js';
import ImageCropperModal from './ImageCropperModal.vue';

export default {
  components: {
    ImageCropperModal,
  },
  props: {
    modelValue: Object,
    customUtmParameters: {
      type: [Object, Array],
      default: () => [],
    },
  },
  emits: ['update:modelValue', 'optimize-start', 'optimize-end', 'page-data-fetched'],
  data: function () {
    return {
      isError: false,
      errorMessage: '',
      errors: {
        messageIcon: '',
        messageLargeImage: '',
        messageBadge: '',
      },
      acceptableMimeTypes: ['image/png', 'image/jpeg', 'image/gif'],
      timer: null,
      // 追加大型画像をユーザーが選択・クリアするたびに進め、それ以前に始めた最適化結果を捨てる
      largeImageVersion: 0,
      isDeprecatedSize: false,
      isImproveModalActive: false,
      isImproveLoading: false,
      improveResult: null,
      improveOriginalTitle: '',
      improveOriginalText: '',
    };
  },
  computed: {
    canAnalyze() {
      return !!(this.modelValue.messageTitle && this.modelValue.messageTitle.trim()
        && this.modelValue.messageText && this.modelValue.messageText.trim()
        && this.modelValue.clickUrl && this.modelValue.clickUrl.trim());
    },
    messageTitle: {
      get() {
        return this.modelValue.messageTitle;
      },
      set(messageTitle) {
        this.updateValue({
          messageTitle
        });
      }
    },
    messageText: {
      get() {
        return this.modelValue.messageText;
      },
      set(messageText) {
        this.updateValue({
          messageText
        });
      }
    },
    clickUrl: {
      get() {
        return this.modelValue.clickUrl;
      },
      set(clickUrl) {
        this.updateValue({
          clickUrl
        });
        if (clickUrl) {
          this.fetchPageData(clickUrl);
        }
      }
    },
    iconUrl: {
      get() {
        return this.modelValue.iconUrl;
      },
      set(iconUrl) {
        this.updateValue({
          iconUrl
        });
      }
    },
    selectedIconFile: {
      get() {
        return this.modelValue.selectedIconFile;
      },
      set(selectedIconFile) {
        this.updateValue({
          selectedIconFile
        });
      }
    },
    largeImageUrl: {
      get() {
        return this.modelValue.largeImageUrl;
      },
      set(largeImageUrl) {
        this.updateValue({
          largeImageUrl
        });
      }
    },
    selectedLargeImageFile: {
      get() {
        return this.modelValue.selectedLargeImageFile;
      },
      set(selectedLargeImageFile) {
        this.updateValue({
          selectedLargeImageFile
        });
      }
    },
    badgeUrl: {
      get() {
        return this.modelValue.badgeUrl;
      },
      set(badgeUrl) {
        this.updateValue({
          badgeUrl
        });
      }
    },
    selectedBadgeFile: {
      get() {
        return this.modelValue.selectedBadgeFile;
      },
      set(selectedBadgeFile) {
        this.updateValue({
          selectedBadgeFile
        });
      }
    },
    hasButtonA: {
      get() {
        return this.modelValue.hasButtonA;
      },
      set(hasButtonA) {
        this.updateValue({
          hasButtonA
        });
      }
    },
    actionButtonTextA: {
      get() {
        return this.modelValue.actionButtonTextA;
      },
      set(actionButtonTextA) {
        this.updateValue({
          actionButtonTextA
        });
      }
    },
    actionButtonUrlA: {
      get() {
        return this.modelValue.actionButtonUrlA;
      },
      set(actionButtonUrlA) {
        this.updateValue({
          actionButtonUrlA
        });
      }
    },
    hasButtonB: {
      get() {
        return this.modelValue.hasButtonB;
      },
      set(hasButtonB) {
        this.updateValue({
          hasButtonB
        });
      }
    },
    actionButtonTextB: {
      get() {
        return this.modelValue.actionButtonTextB;
      },
      set(actionButtonTextB) {
        this.updateValue({
          actionButtonTextB
        });
      }
    },
    actionButtonUrlB: {
      get() {
        return this.modelValue.actionButtonUrlB;
      },
      set(actionButtonUrlB) {
        this.updateValue({
          actionButtonUrlB
        });
      }
    },
    adFlag: {
      get() {
        return this.modelValue.adFlag;
      },
      set(adFlag) {
        this.updateValue({
          adFlag
        });
      }
    },
    customUtmParameter: {
      get() {
        return this.modelValue.customUtmParameter;
      },
      set(customUtmParameter) {
        this.updateValue({
          customUtmParameter
        });
      }
    },
    customUtmParameterActionA: {
      get() {
        return this.modelValue.customUtmParameterActionA;
      },
      set(customUtmParameterActionA) {
        this.updateValue({
          customUtmParameterActionA
        });
      }
    },
    customUtmParameterActionB: {
      get() {
        return this.modelValue.customUtmParameterActionB;
      },
      set(customUtmParameterActionB) {
        this.updateValue({
          customUtmParameterActionB
        });
      }
    },
    useCustomParameter: function() {
      // 権限チェック
      if (!store.getResourceAccessRules()['CUSTOM_PARAMETER']) {
        return false;
      }
      // カスタムパラメータが存在するかチェック（キー'0'の空の選択肢以外があるか）
      const params = this.customUtmParameters;
      if (!params || typeof params !== 'object') {
        return false;
      }
      const keys = Object.keys(params);
      // キーが1個以下（空の選択肢のみ）または、キーが'0'のみの場合は非表示
      return keys.length > 1 || (keys.length === 1 && keys[0] !== '0');
    }
  },
  watch: {
    largeImageUrl(newVal, _oldVal) {
      this.isDeprecatedSize = false;
      if (newVal) {
        const image = new Image();
        image.onload = () => {
          if (image.height > image.width) {
            this.isDeprecatedSize = true;
          }
        }
        image.src = newVal;
      }
    }
  },
  mounted: function() {
    // RSSメッセージ作成
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('url')) {
      this.clickUrl = searchParams.get('url');
    }
  },
  methods: {
    isSystemAdminEdit() {
      return store.state.user.isSystemAdminEdit;
    },
    updateValue(target) {
      // 親のv-modelを更新
      this.$emit('update:modelValue', {
        ...this.modelValue,
        ...target,
      });
    },
    isAcceptableMimeType: function (mimeType) {
      var isAcceptable = false;
      this.acceptableMimeTypes.forEach(function (acceptableMimeType) {
        if (acceptableMimeType == mimeType) {
          isAcceptable = true;
        }
      });
      return isAcceptable;
    },
    selectIconFile: function () {
      let iconFile = this.$refs.iconInput.files[0];

      // ファイルが選択されていない場合は何もしない
      if (!iconFile) {
        return;
      }

      // MIMEタイプチェック
      if (!this.isAcceptableMimeType(iconFile.type)) {
        this.isError = true;
        this.errorMessage = '通知アイコンはPNG/JPEG/GIF形式のファイルを指定してください。';
        this.errors.messageIcon = '通知アイコンはPNG/JPEG/GIF形式のファイルを指定してください。';
        return;
      }

      this.errors.messageIcon = '';

      // ファイルオブジェクトを即座に設定
      // 正方形かつ8KB以下の画像の場合、このまま使用される
      // それ以外の場合は後でクリアされ、モーダル確定時にonIconCroppedで設定し直される
      this.selectedIconFile = iconFile;

      // 画像の寸法とサイズをチェック
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        const img = new Image();
        img.addEventListener('load', () => {
          const isSquare = img.width === img.height;
          const isSmallEnough = iconFile.size <= 8192;

          if (isSquare && isSmallEnough) {
            // 正方形で8KB以下の場合はプレビュー用のiconUrlのみ設定
            this.iconUrl = reader.result;
          } else {
            // 正方形でない、または8KBを超える場合はモーダル表示
            // selectedIconFileをクリアして、モーダル確定時に設定し直す
            this.selectedIconFile = null;
            this.$refs.imageCropperModal.showModal(iconFile);
          }
        });
        img.src = reader.result;
      });
      reader.readAsDataURL(iconFile);
    },
    onIconCropped: function (croppedFile) {
      // トリミング・圧縮された画像を設定
      this.selectedIconFile = croppedFile;

      // プレビュー表示
      const reader = new FileReader();
      reader.addEventListener(
        'load',
        () => {
          this.iconUrl = reader.result;
        },
        false
      );
      reader.readAsDataURL(croppedFile);

      // ファイル入力をクリア（同じファイルを再選択できるように）
      this.$refs.iconInput.value = '';
    },
    onIconCropCancelled: function () {
      // キャンセル時もファイル入力をクリア（同じファイルを再選択できるように）
      this.$refs.iconInput.value = '';
    },
    onLargeImageCropped: function (croppedFile) {
      this.largeImageVersion++;
      // トリミング・圧縮された画像を設定
      this.selectedLargeImageFile = croppedFile;

      // プレビュー表示
      const reader = new FileReader();
      reader.addEventListener(
        'load',
        () => {
          this.largeImageUrl = reader.result;
        },
        false
      );
      reader.readAsDataURL(croppedFile);

      // ファイル入力をクリア（同じファイルを再選択できるように）
      this.$refs.largeImageInput.value = '';
    },
    onLargeImageCropCancelled: function () {
      // キャンセル時もファイル入力をクリア（同じファイルを再選択できるように）
      this.$refs.largeImageInput.value = '';
    },

    selectLargeImageFile: function () {
      let largeImageFile = this.$refs.largeImageInput.files[0];

      // ファイルが選択されていない場合は何もしない
      if (!largeImageFile) {
        return;
      }

      this.errors.messageLargeImage = '';

      // MIMEタイプチェック
      if (!this.isAcceptableMimeType(largeImageFile.type)) {
        this.isError = true;
        this.errorMessage = '追加大型画像はPNG/JPEG/GIF形式のファイルを指定してください。';
        this.errors.messageLargeImage = '追加大型画像はPNG/JPEG/GIF形式のファイルを指定してください。';
        return;
      }

      this.largeImageVersion++;

      // ファイルオブジェクトを即座に設定
      // 128KB以下の画像の場合、このまま使用される
      // 128KBを超える場合は後でクリアされ、モーダル確定時にonLargeImageCroppedで設定し直される
      this.selectedLargeImageFile = largeImageFile;

      // ファイルサイズをチェック
      const isSmallEnough = largeImageFile.size <= 131072; // 128KB

      if (isSmallEnough) {
        // 128KB以下の場合はそのまま使用
        const reader = new FileReader();
        reader.addEventListener('load', () => {
          this.largeImageUrl = reader.result;
        });
        reader.readAsDataURL(largeImageFile);
      } else {
        // 128KBを超える場合はモーダル表示
        // selectedLargeImageFileをクリアして、モーダル確定時に設定し直す
        this.selectedLargeImageFile = null;
        this.$refs.imageCropperModalLarge.showModal(largeImageFile);
      }
    },
    selectBadgeFile: function () {
      let badgeFile = this.$refs.badgeInput.files[0];
      this.errors.messageBadge = '';

      if (badgeFile.size > 8192) {
        this.isError = true;
        this.errorMessage = 'ステータスアイコンは8KB以下のファイルを指定してください。';
        this.errors.messageBadge = 'ステータスアイコンは8KB以下のファイルを指定してください';
        return;
      }

      if (badgeFile.type != 'image/png') {
        this.isError = true;
        this.errorMessage = 'ステータスアイコンはPNG形式のファイルを指定してください。';
        this.errors.messageBadge = 'ステータスアイコンはPNG形式のファイルを指定してください。';
        return;
      }

      const fileReader = new FileReader();
      const self = this;

      self.checkImageTransparency(fileReader);
      fileReader.readAsDataURL(badgeFile);

      this.selectedBadgeFile = badgeFile;
    },
    analyzeMessage: function () {
      if (!this.messageTitle && !this.messageText) {
        this.isError = true;
        this.errorMessage = 'タイトルまたは本文を入力してください。';
        return;
      }
      this.improveResult = null;
      this.improveOriginalTitle = this.messageTitle || '';
      this.improveOriginalText = this.messageText || '';
      this.isImproveModalActive = true;
      this.isImproveLoading = true;
      window.axios
        .post('/api/message/analyze', {
          title: this.messageTitle || '',
          text: this.messageText || '',
          url: this.clickUrl || '',
        })
        .then((res) => {
          this.improveResult = res.data;
        })
        .catch(() => {
          this.isImproveModalActive = false;
          this.isError = true;
          this.errorMessage = 'メッセージ分析に失敗しました。しばらくしてから再度お試しください。';
        })
        .finally(() => {
          this.isImproveLoading = false;
        });
    },
    applyImprovement: function ({ title, text }) {
      const update = {};
      if (title) update.messageTitle = title;
      if (text) update.messageText = text;
      if (Object.keys(update).length > 0) {
        this.updateValue(update);
      }
      this.isImproveModalActive = false;
    },
    closeImproveModal: function () {
      this.isImproveModalActive = false;
    },
    clearMessageTitleContent: function () {
      this.updateValue({ messageTitle: '', messageText: '' });
    },
    addUtmPrameter: function () {
      const key1 = 'utm_source';
      const val1 = 'webpush';
      const key2 = 'utm_medium';
      const val2 = 'pushone';

      try {
        const url = new URL(this.clickUrl);
        const searchParams = new URLSearchParams(url.search);
        if (!searchParams.has(key1) && searchParams.get(key1) != val1) {
          searchParams.append(key1, val1);
        }
        if (!searchParams.has(key2) && searchParams.get(key2) != val2) {
          searchParams.append(key2, val2);
        }
        url.search = searchParams.toString();
        this.clickUrl = url.href;
      } catch {
        this.isError = true;
        this.errorMessage = '遷移先のURLが不正です';
        return;
      }
    },
    clearLargeImageFile: function () {
      this.largeImageVersion++;
      this.updateValue({ selectedLargeImageFile: null, largeImageUrl: '' });
      this.$refs.largeImageInput.value = '';
    },
    clearBadgeFile: function () {
      this.updateValue({ selectedBadgeFile: null, badgeUrl: '' });
      this.$refs.badgeInput.value = '';
    },
    addButtonB: function () {
      this.hasButtonB = true;
    },
    hideButtonB: function () {
      this.hasButtonB = false;
    },
    checkMessageFormat(text) {
      const pattern = /[<>]/g;
      return !pattern.test(text);
    },
    checkLength(text, max) {
      return text.length <= max;
    },
    validate: function (errors) {
      if (!this.messageTitle) {
        errors['message_title'] = 'タイトルを入力してください';
      } else if (!this.checkMessageFormat(this.messageTitle)) {
        errors['message_title'] = '使用出来ない文字が含まれています';
      } else if (!this.checkLength(this.messageTitle, 140)) {
        errors['message_title'] = 'タイトルは140文字以内で入力してください';
      }

      if (!this.messageText) {
        errors['message_content'] = '本文を入力してください';
      } else if (!this.checkMessageFormat(this.messageText)) {
        errors['message_content'] = '使用出来ない文字が含まれています';
      } else if (!this.checkLength(this.messageText, 1024)) {
        errors['message_content'] = '本文は1024文字以内で入力してください';
      }

      if (!this.clickUrl) {
        errors['redirect_url'] = 'URLを入力してください';
      } else if (this.clickUrl?.length > 1024) {
        errors['redirect_url'] = 'URLは1024文字以内で入力してください';
      }

      if (this.hasButtonA == 1) {
        if (!this.actionButtonTextA) {
          errors['select_btn_title_1'] = '選択ボタン1のタイトルを入力してください';
        } else if (this.actionButtonTextA?.length > 8) {
          errors['select_btn_title_1'] = 'タイトルは8文字以内で入力してください';
        }
        if (!this.actionButtonUrlA) {
          errors['select_btn_url_1'] = 'URLを入力してください';
        } else if (this.actionButtonUrlA?.length > 1024) {
          errors['select_btn_url_1'] = 'URLは1024文字以内で入力してください';
        }
      }

      if (this.hasButtonA == 1 && this.hasButtonB) {
        if (!this.actionButtonTextB) {
          errors['select_btn_title_2'] = '選択ボタン2のタイトルを入力してください';
        } else if (this.actionButtonTextB?.length > 8) {
          errors['select_btn_title_2'] = 'タイトルは8文字以内で入力してください';
        }
        if (!this.actionButtonUrlB) {
          errors['select_btn_url_2'] = 'URLを入力してください';
        } else if (this.actionButtonUrlB?.length > 1024) {
          errors['select_btn_url_2'] = 'URLは1024文字以内で入力してください';
        }
      }
    },

    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function () {
      this.isError = false;
      this.errorMessage = '';
    },
    optimizeImage: function (params, callback) {
      const endpoint = 'https://bpjflajowoc3zds6vfdqnhcfs40irvbj.lambda-url.ap-northeast-1.on.aws';
      this.$emit('optimize-start');
      axios
        .post(endpoint, params)
        .then((res) => {
          callback(res.data);
        })
        .catch((_e) => {
          callback(null);
        })
        .finally(() => {
          this.$emit('optimize-end');
        });
    },
    fetchPageData: function (clickUrl) {
      if (this.timer) {
        window.clearTimeout(this.timer);
        this.timer = null;
      }

      // ogタグの設定項目を全て入力している場合
      if (
        this.modelValue.messageTitle != null &&
        this.modelValue.messageTitle.length != 0 &&
        this.modelValue.messageText != null &&
        this.modelValue.messageText.length != 0 &&
        this.modelValue.largeImageUrl != null &&
        this.modelValue.largeImageUrl.length != 0
      ) {
        return;
      }

      const self = this;
      this.timer = window.setTimeout(function () {
        axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
        axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
        axios
          .post(`https://iiuvxxdu47ve2nlsweutxtjiau0wobcl.lambda-url.ap-northeast-1.on.aws/`, {
            url: clickUrl,
          })
          .then((res) => {
            // 応答待ちの間に URL が変わっていたら、古い URL の内容は反映しない
            if (clickUrl !== self.modelValue.clickUrl) {
              return;
            }

            // 親の modelValue は次の描画まで更新されないため、タイトルと本文は1回の emit にまとめる
            const target = {};
            if (!self.modelValue.messageTitle) {
              target.messageTitle = res.data.title;
            }

            if (!self.modelValue.messageText) {
              target.messageText = res.data.body;
            }

            if (Object.keys(target).length > 0) {
              self.updateValue(target);
              self.$emit('page-data-fetched', target);
            }

            if (res.data.image_data && !self.modelValue.largeImageUrl) {
              const largeImageVersion = self.largeImageVersion;
              self.optimizeImage(
                { max_bytes: 131072, max_size: 480, data: res.data.image_data },
                function (optimizedImage) {
                  // 最適化中に URL が変わった、またはユーザーが画像を選択・クリアした場合は反映しない
                  if (clickUrl !== self.modelValue.clickUrl || largeImageVersion !== self.largeImageVersion) {
                    return;
                  }
                  if (optimizedImage) {
                    self.largeImageUrl = optimizedImage.data;
                  }
                }
              );
            }
          })
          .catch((_e) => {});
      }, 500);
    },
    checkImageTransparency: function (fileReader) {
      fileReader.onload = () => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);
          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          const alphaChannel = imageData.data.filter((_, i) => (i + 1) % 4 === 0);
          if (alphaChannel.some((alpha) => alpha !== 255)) {
            this.badgeUrl = fileReader.result;
          } else {
            this.isError = true;
            this.errorMessage = 'ステータスアイコンは透過されたPNG形式のファイルを指定してください。';
            this.errors.messageBadge =
              'ステータスアイコンは透過されたPNG形式のファイルを指定してください。';
          }
        };
        img.src = fileReader.result;
      };
    },
    onCustomUtmParameterSelect: function (selected) {
      this.updateValue({ customUtmParameter: selected });
    },
    onCustomUtmParameterActionASelect: function (selected) {
      this.updateValue({ customUtmParameterActionA: selected });
    },
    onCustomUtmParameterActionBSelect: function (selected) {
      this.updateValue({ customUtmParameterActionB: selected });
    },
  },
};
</script>

<style scoped>
.uploaded_transparent_image {
    margin: 0;
    padding: 0;
    background-color: #fff;
    background-image: linear-gradient(45deg, #ddd 25%, transparent 25%, transparent 75%, #ddd 75%, #ddd),
        linear-gradient(45deg, #ddd 25%, transparent 25%, transparent 75%, #ddd 75%, #ddd);
    background-size: 18px 18px;
    background-position: 0 0, 9px 9px;
    overflow: hidden;
}

.c-help-tooltip {
    position: relative;
    top: -115px;
    left: 360px;
    width: 20px;
}

.c-help-tooltip > svg {
    height: 20px;
    width: 20px;
}

.c-help-tooltip__text {
    position: absolute;
    width: 700px;
    top: 33px;
    left: -240px;
    visibility: hidden;
    opacity: 0;
    transition: 0.5s all;
    /* border: solid 1px #999; */
    background: #eef8f8;
    border-radius: 5px;
    padding: 10px;
    font-size: small;
    box-shadow: -1px 4px 0px #eef8f8, 0px 0px 10px #ccc, 1px 5px 5px #aaa;
    z-index: 1000;
}

.c-help-tooltip:hover .c-help-tooltip__text {
    visibility: visible;
    opacity: 1;
}
</style>
